import { Component, Input } from '@angular/core';

@Component({
  selector: 'mprd-modem-choice-entrypoint',
  templateUrl: './modem-choice-entrypoint.component.html',
})
export class ModemChoiceEntrypointComponent {
  @Input() circuitId = '';
}
